/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-13 09:51:47
 * @LastEditors: linguang linguang@nextmar.com
 * @LastEditTime: 2025-04-13 09:52:09
 * @FilePath: /zeelool-nextjs/src/utils/enums/common.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export enum YES_NO {
  YES = 1,
  NO = 2,
}

// 订单的状态常量
export enum ORDER_STATUS {
  DELIVERY = 'delivery',
  CLOSED = 'closed',
  SHIPPED = 'shipped',
  PROCESSING = 'processing',
  UNPAID = 'unpaid',
}
